import { queryAsinInfo } from '@/api/ad'
import Vue from 'vue'

/**
 * 获取ASIN 信息
 * @param {*} key 代表asin字段
 * @param {*} marketId 
 * @param {*} countryCode 
 * @param {*} arr 列表
 * @param {*} imgKey 指定的图片key
 * @param {*} list
 */
export const getAsinInfo = async (key, marketId, countryCode, arr, imgKey = 'imageUrl', list = null) => {
  try {
    const asinList = list ? list : arr.filter(item => {
      // return item.expressionList.find(item => ['asinExpandedFrom', 'asinSameAs'].indexOf(item.type) > -1) !== undefined
      return true;
    }).map(item => item[key]?.toLocaleUpperCase());
    const fragment = [];
    const slicing = () => {
        fragment.push(asinList.splice(0, 10));
        if (asinList.length > 10) {
            slicing();
        } else {
            asinList.length && fragment.push(asinList);
        }
    };
    slicing();
    const asinsData = await Promise.all(
        fragment.map(
          (item) =>
            item.length && queryAsinInfo({
              asinList: item,
              countryCode,
              marketId
            })
        )
      );
    let imgObj = {};
    asinsData.forEach(item => {
       imgObj = {...imgObj, ...item}
    })
    arr.forEach((item, index) => {
      item[imgKey] = imgObj[item[key]?.toLocaleUpperCase()]?.imageUrl || null;
      Vue.set(arr, index, item);
    })
  } catch (error) {
    console.error('asin-info方法报错', error)
  }
}